<div class="hero-banner">
  <div class="container">
    <div class="row text--center">
      <div [innerHTML]="data"></div>
    </div>
  </div>
</div>
